import { GridController, gridTpl } from '../../../../../common/grid/grid.controller';
import { IDS } from '../../settings-action-id.constants';
import * as Actions from '../evidence-list.actions';

class ApplicableSitesGridController extends GridController {
    constructor($ngRedux, $state, NavigationService, $filter, $mdDialog, $scope) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
    }

    $onInit() {
        this.module = 'accreditation';
        this.identifier = IDS.accSettings;
        this.statePath = IDS.evidenceApplicableSitesGrid;
        this.filterComponent = false;
        this.exportComponent = false;
        this.confirmDialogOnRemove = true;
        // this.icon = false;

        this.columns = [
            {title: 'Applicable Site Locations', mapper: 'name'},
            {title: 'Enabled', mapper: 'checkbox', identifier:this.identifier, statePath: this.statePath, style:{width:'35px'}},
        ];

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), Actions)(this);
        this.dataAction = this.fetchEvidenceApplicableSitesGrid;

        this.init();
    }

    $onDestroy() {
        this.destroy();
    }
}

ApplicableSitesGridController.$inject = ['$ngRedux', '$state', 'NavigationService', '$filter', '$mdDialog', '$scope'];

export const evidenceApplicableSitesGrid = {
    bindings: {
        title: '@',
    },
    controller: ApplicableSitesGridController,
    ...gridTpl
}
